import ValidationInterface from '@/plans/common/validation-interface';
import { basePlanCategories } from '@/common/persist-cart/categories';

export default class extends ValidationInterface {
  async requires(cart) {
    if (cart.config?.enableCAICSwitchToStandalone) {
      return [];
    }
    return [this.current("CAIC").require(basePlanCategories)];
  }

  async conflicts() {
    return this.current(["CAIC"]).conflict(["CAIC"]);
  }
}
